<template>
    <v-sheet
        style="margin: 2px; position: relative; padding-left: 6px; padding-right: 6px"
        class="cursor-pointer transition-ease-in-out rounded"
        :class="isMenuOpen ? 'elevation-1 menu-open' : ''"
    >
        <v-row
            align="center"
            no-gutters
            class="d-flex align-center flex-nowrap"
            v-on="on"
        >
            <div class="flex-shrink-0 d-flex align-center mr-1">
                <icon
                    v-if="eventIconData"
                    :icon="eventIconData.icon"
                    :color="eventIconData.color"
                    size="16"
                />
            </div>
            <div
                style="font-size: 12px; line-height: 16px;"
                class="text-truncate mr-2 n5--text py-1"
            >
                {{ calendarEvent.name }}
            </div>
        </v-row>
    </v-sheet>
</template>

<script>
import {computed} from "@vue/composition-api";
import { $t } from "@/i18n";
import { getInitials } from "@/modules/initials";

import AccountAvatar from "@/components/AccountAvatar.vue";
import {getEventIconData} from "@/modules/calendar/calendar";
import ClientAvatar from "@/components/ClientAvatar.vue";

export default {
    name: "CalendarEventActivator",
    components: {ClientAvatar, AccountAvatar},
    props: {
        on: {
            type: Object,
            required: true
        },
        calendarEvent: {
            type: Object,
            required: true
        },
        isMenuOpen: {
            type: Boolean,
            required: true
        }
    },
    setup(props, ctx) {
        const eventIconData = computed(() => {
            return getEventIconData(props.calendarEvent.type)
        })

        return {
            getInitials,
            eventIconData
        };
    }
};
</script>

<style scoped lang="scss">
.v-sheet {
    background: rgba(37, 57, 87, 0.08);

    &.menu-open, &:hover {
        background: rgba(37, 57, 87, 0.16);
    }
}

</style>